<template>
  <div class="c-filter">
    <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
      <div>
        <ElFormItem label="计划">
          <el-input class="plan-input" style="width: 150px" @focus="isShowDialog('计划选择', '计划')">
            <i class="el-icon-arrow-down" slot="suffix"> </i>
            <template slot="prepend">
              <div class="prepend" @click.stop="isShowDialog('计划选择', '计划')">
                <el-tag type="info" class="cursor-pointer" v-if="planTags && planTags.length">
                  <span :title="planTags.map((i) => i.name).join(', ')">{{ planTags[0].name }}</span>
                </el-tag>
                <em v-if="planTags.length > 1">+ {{ planTags.length - 1 }}</em>
              </div>
            </template>
          </el-input>
        </ElFormItem>
        <ElFormItem label="素材">
          <el-input class="plan-input" style="width: 150px" @focus="isShowDialog('素材选择', '素材')">
            <i class="el-icon-arrow-down" slot="suffix"> </i>
            <template slot="prepend">
              <div class="prepend" @click.stop="isShowDialog('素材选择', '素材')">
                <el-tag type="info" class="cursor-pointer" v-if="imageTags && imageTags.length">
                  <span :title="imageTags.map((i) => i.name).join(', ')">{{ imageTags[0].name }}</span>
                </el-tag>
                <em v-if="imageTags.length > 1">+ {{ imageTags.length - 1 }}</em>
              </div>
            </template>
          </el-input>
        </ElFormItem>
        <ElFormItem label="平台">
          <el-select v-model="platforms" multiple collapse-tags filterable clearable style="width: 120px" placeholder="请选择">
            <el-option v-for="item in platformsData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="应用组">
          <el-select v-model="gameGroupIds" style="width: 180px" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="(item, index) in GAME_GROUPS" :key="index" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="应用" label-width="38">
          <el-select v-model="gameIds" style="width: 180px" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="(item, index) in GAMES" :key="index" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="项目组">
          <el-select v-model="initProjectGroupIds" style="width: 180px" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="(item, index) in PROJECT_GROUP" :key="index" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="人员" label-width="38">
          <el-select v-model="opIds" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="item in PTOM_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="媒体" label-width="38">
          <el-select v-model="mediaIds" multiple collapse-tags filterable clearable placeholder="请选择" @change="handleMedia">
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="投放位">
          <el-select v-model="advPositionIds" multiple collapse-tags filterable clearable style="width: 170px" placeholder="请选择">
            <el-option v-for="item in advertPositionData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="账号" label-width="38">
          <el-select v-model="adAccountIdList" style="width: 180px" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="item in MEDIA_ACCOUNTS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="优化目标">
          <el-select v-model="optimizationTypes" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="item in optimizationData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="深度优化目标" label-width="90">
          <el-select v-model="deepOptimizationTypes" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="item in deepOptimizationData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="流量来源">
          <el-select v-model="launchSource" clearable style="width: 90px" placeholder="全部">
            <el-option v-for="item in launchSourceData" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="是否代投" label-width="60">
          <el-select v-model="proxyFlag" style="width: 160px" collapse-tags clearable>
            <el-option v-for="item in proxyStatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </ElFormItem>
        <el-button type="primary" @click="sendEvent">查询</el-button>
        <el-button type="text" @click="clearAll('screen')">清空</el-button>
      </div>
      <div>
        <dimension
          :config="{ indeterminate: false, key: 'key' }"
          :dimensions="dimensions"
          @handleCheckAllChange="handleCheckAllChange"
          @handleCheckedDimensChange="handleCheckAllChange"
        >
        </dimension>
      </div>
    </ElForm>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="62%">
      <filter-dialog
        ref="filter"
        :title="title"
        :backPlan="backPlan"
        :backImage="backImage"
        :filtersData="{ MEDIAS, MEDIA_ACCOUNTS, PTOM_USERS, GAME_GROUPS, GAMES }"
      ></filter-dialog>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/**
 * @description: 综合效果报表与小程序综合效果报表公用一个查询组件
 */
import { optimization, deepOptimization } from '../../comprehension-report/js/filterData.js'
import FilterDialog from '../../comprehension-report/components/filter-dialog.vue'
import { initPageData, PROJECT_GROUP, MEDIA_POSITION, MEDIA_ACCOUNTS, GAME_GROUPS, GAMES, MEDIAS, PTOM_USERS } from '@/data/global-opts'
import Dimension from '@/components/dimension/index.vue'
import { transferTaskQueryConditions } from '@/views/download-center/data/utils.js'
// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([PROJECT_GROUP, MEDIA_POSITION, MEDIA_ACCOUNTS, GAME_GROUPS, GAMES, MEDIAS, PTOM_USERS])

export default {
  name: 'detailFilter',
  components: {
    FilterDialog,
    Dimension
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    advertPositionData() {
      const data = []
      if (this.mediaIds && this.mediaIds.length) {
        this.MEDIA_POSITION.filter((res) => this.mediaIds.map((item) => res.mediaId === item && data.push(res)))
      }
      return data
    },
    optimizationData() {
      return this.filterTargets(this.optimization)
    },
    deepOptimizationData() {
      return this.filterTargets(this.deepOptimization)
    },
    planTags() {
      return this.planTagLists
    },
    imageTags() {
      return this.imageTagLists
    }
  },
  data() {
    return {
      optimization,
      deepOptimization,
      filtersData: {},
      platforms: [],
      platformsData: [
        { id: 1, name: '安卓' },
        { id: 2, name: 'iOS' },
        { id: 3, name: '小程序' }
      ],
      dimensions: [
        {
          label: '投放位',
          key: 'dimAdvPosition',
          columnKey: 'advPositionName',
          checked: true,
          disabled: true
        },
        {
          label: '平台',
          key: 'dimPlatform',
          columnKey: 'platform',
          disabled: false
        },
        {
          label: '媒体',
          key: 'dimMedia',
          columnKey: 'mediaName',
          disabled: false
        },
        {
          label: '优化目标',
          key: 'dimOptimizationType',
          columnKey: 'optimizationTypeName',
          disabled: false
        },
        {
          label: '深度优化目标',
          key: 'dimDeepOptimizationType',
          columnKey: 'deepOptimizationTypeName',
          disabled: false
        },
        {
          label: '账号',
          key: 'dimAdAccount',
          columnKey: 'adAccountName',
          disabled: false
        },
        {
          label: '人员',
          key: 'dimOp',
          columnKey: 'opName',
          disabled: false
        }
      ],
      dimensionFilter: { dimAdvPosition: 1 },
      gameGroupIds: [],
      gameIds: [],
      initProjectGroupIds: [],
      opIds: [],
      mediaIds: [],
      advPositionIds: [],
      adAccountIdList: [],
      optimizationTypes: [],
      deepOptimizationTypes: [],
      launchSource: '',
      launchSourceData: [
        {
          value: 1,
          label: '自然量'
        },
        {
          value: 2,
          label: '投放量'
        }
      ],
      title: '',
      backPlan: [],
      backImage: [],
      dialogVisible: false,
      planTagLists: [],
      imageTagLists: [],
      proxyFlag: '',
      proxyStatus: [
        { id: 1, name: '是' },
        { id: 0, name: '否' }
      ]
    }
  },
  created() {
    this.sendEvent()
  },
  methods: {
    handleCheckAllChange(val1, val2) {
      this.dimensionFilter = {}
      val2.map((mp) => {
        this.dimensionFilter[mp] = 1
      })
    },
    filterTargets(filterType) {
      let data = []
      const obj = {}
      if (this.mediaIds && this.mediaIds.length) {
        filterType.filter((res) => this.mediaIds.map((item) => res.media && res.media.includes(item) && data.push(res)))
        data = data.reduce((cur, next) => {
          // eslint-disable-next-line no-unused-expressions
          obj[next.id] ? '' : (obj[next.id] = true && cur.push(next))
          return cur
        }, [])
      }
      return data
    },
    /**
     * @description: 添加导出任务时转化查询条件为可读的字符串
     * @param {*} extraParams
     * @param {*} pageType
     * @return {*}
     */
    getTransferedTaskQueryConditions(extraParams, pageType) {
      return transferTaskQueryConditions.call(this, { ...this.buildParams(), ...extraParams }, pageType)
    },
    buildParams() {
      return {
        platforms: this.platforms.length ? this.platforms : undefined,
        gameGroupIds: this.gameGroupIds.length ? this.gameGroupIds : undefined,
        gameIds: this.gameIds.length ? this.gameIds : undefined,
        initProjectGroupIds: this.initProjectGroupIds.length ? this.initProjectGroupIds : undefined,
        opIds: this.opIds.length ? this.opIds : undefined,
        mediaIds: this.mediaIds.length ? this.mediaIds : undefined,
        advPositionIds: this.advPositionIds.length ? this.advPositionIds : undefined,
        adAccountIdList: this.adAccountIdList.length ? this.adAccountIdList : undefined,
        optimizationTypes: this.optimizationTypes.length ? this.optimizationTypes : undefined,
        deepOptimizationTypes: this.deepOptimizationTypes.length ? this.deepOptimizationTypes : undefined,
        launchSource: this.launchSource === '' ? undefined : this.launchSource,
        ptomPlan: this.planTagLists.length ? this.planTagLists : undefined,
        ptomImage: this.imageTagLists.length ? this.imageTagLists : undefined,
        proxyFlag: this.proxyFlag === '' ? undefined : this.proxyFlag,
        ...this.dimensionFilter
        // dimPlan: dimPlan || undefined,
        // dimImage: dimImage || undefined,
        // dimPlatform: dimPlatform || undefined,
        // dimGameGroup: dimGameGroup || undefined,
        // dimGame: dimGame || undefined,
        // dimProjectGroup: dimProjectGroup || undefined,
        // dimOp: dimOp || undefined,
        // dimMedia: dimMedia || undefined,
        // dimAdvPosition: dimAdvPosition || undefined,
        // dimAdAccount: dimAdAccount || undefined,
        // dimOptimizationType: dimOptimizationType || undefined,
        // dimDeepOptimizationType: dimDeepOptimizationType || undefined,
        // dimLaunchSource: dimLaunchSource || undefined
      }
    },
    sendEvent(type) {
      const params = this.buildParams()
      if (type === 'save') this.$emit('on-save', params)
      else {
        const dimens = Object.keys(this.dimensionFilter).map((item) => {
          return { ...this.dimensions.filter((dim) => dim.key === item)[0] }
        })
        this.$emit('on-change', params, dimens)
      }
    },
    // src\views\report\comprehension-report\realtime.vue sendSaveClick调用了方法
    saveFilter() {
      this.sendEvent('save')
    },
    handleMedia(meta) {
      // this.mediaIds = meta.id
      this.optimizationTypes = []
      this.deepOptimizationTypes = []
    },
    clearAll(type) {
      if (type === 'screen') {
        this.clearScreen()
      }
    },
    clearScreen() {
      this.platforms = []
      this.gameGroupIds = []
      this.gameIds = []
      this.initProjectGroupIds = []
      this.opIds = []
      this.mediaIds = []
      this.advPositionIds = []
      this.adAccountIdList = []
      this.optimizationTypes = []
      this.deepOptimizationTypes = []
      this.launchSource = ''
      this.planTagLists = []
      this.imageTagLists = []
    },
    isShowDialog(type, msg) {
      this.title = type
      this.$nextTick(() => {
        this.$refs.filter.plan = {
          mediaIds: [],
          adAccountIdList: [],
          opId: [],
          planName: ''
        }
        this.$refs.filter.image = {
          gameGroupIds: [],
          gameIds: [],
          opIds: [],
          imageName: ''
        }
        this.$refs.filter.getData()
      })
      this.dialogVisible = true
      this.backPlan = this.planTagLists
      this.backImage = this.imageTagLists
    },
    submit() {
      this.dialogVisible = false
      if (this.title === '计划选择') {
        this.planTagLists = this.$refs.filter.getSelectData()
      } else {
        this.imageTagLists = this.$refs.filter.getSelectData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title,
.clear {
  line-height: 32px;
  font-size: 12px;
}
.el-checkbox-group {
  display: inline-block;
}
.c-filter {
  ::v-deep .el-checkbox__label {
    font-size: 12px;
  }
}

.plan-input {
  position: relative;
  cursor: pointer;
  .el-icon-arrow-down {
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translateY(-50%);
  }
}
::v-deep .el-input-group__prepend {
  position: absolute;
  padding: 0;
  width: 100%;
  height: 100%;
  background: none;
  border: none;
  .prepend {
    display: flex;
    align-items: center;
    height: 100%;

    .cursor-pointer {
      > span {
        width: 100%;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    em {
      display: inline-block;
      margin-left: 2px;
      padding: 0 5px;
      line-height: 22px;
      background: #f5f5f5;
      border: 1px solid #e9e9eb;
      border-radius: 4px;
    }
  }
}
::v-deep .el-select .el-tag__close.el-icon-close {
  right: -3px;
  top: 1px;
}
</style>
